export const SUPPORTED_LOCALES = ['zh-CN', 'zh-TW', 'en-US'] as const;

export type Locale = (typeof SUPPORTED_LOCALES)[number];
export type LocaleMode = 'SYSTEM' | 'USER';

export type LocaleKey =
  | 'consult_prompt.title'
  | 'consult_prompt.help'
  | 'consult_prompt.ready'
  | 'consult_prompt.pending'
  | 'consult_prompt.prepare'
  | 'consult_prompt.confirm'
  | 'consult_prompt.cancel'
  | 'consult_prompt.billing'
  | 'consult_prompt.reason'
  | 'consult_prompt.failed'
  | 'roles.permission_directory'
  | 'roles.permission_column'
  | 'roles.permission_count'
  | 'roles.risk_column'
  | 'roles.risk_explanation'
  | 'roles.risk_count'
  | 'roles.risk.R0'
  | 'roles.risk.R1'
  | 'roles.risk.R2'
  | 'roles.risk.R3'
  | 'roles.risk.R4'
  | 'roles.risk.unknown'
  | 'roles.no_permissions'
  | 'roles.all_permissions'
  | 'roles.builtin_risk'
  | 'roles.builtin_explanation'
  | 'roles.template_title'
  | 'roles.template_help'
  | 'identity.required'
  | 'identity.steps'
  | 'identity.setup'
  | 'identity.verify'
  | 'identity.recheck'
  | 'identity.failed'
  | 'identity.reason'
  | 'identity.search_failed'
  | 'topup.lost_authenticator'
  | 'topup.security_link'
  | 'topup.title'
  | 'topup.title_user'
  | 'topup.submit'
  | 'topup.cancel'
  | 'topup.amount'
  | 'topup.reason'
  | 'topup.checking'
  | 'topup.setup_required'
  | 'topup.setup_steps'
  | 'topup.setup_link'
  | 'topup.refresh'
  | 'topup.verify_required'
  | 'topup.verify_steps'
  | 'topup.code'
  | 'topup.failed'
  | 'topup.user_required'
  | 'topup.amount_required'
  | 'topup.reason_required'
  | 'topup.code_required'
  | 'topup.success'
  | 'topup.reload_failed'
  | 'common.loading'
  | 'common.page_loading'
  | 'auth.permission_loading'
  | 'errors.permission_load_failed'
  | 'errors.permission_unavailable'
  | 'auth.check_again'
  | 'auth.sign_out'
  | 'common.language_follow_system'
  | 'common.language_user_selected'
  | 'common.language'
  | 'common.language_zh_cn'
  | 'common.language_zh_tw'
  | 'common.language_en_us';

export type LocaleCatalog = Readonly<Record<LocaleKey, string>>;

export type LocalePreference = Readonly<{
  localeMode: LocaleMode;
  locale?: Locale;
}>;
